export default [
  { name: 'flat', symbol: 'b', alter: -1 },
  { name: 'none', symbol: '', alter: 0 },
  { name: 'sharp', symbol: '#', alter: 1 },
];
